import FilterUser from 'components/orders/Filters/Filters/Users/component';

export default FilterUser;
